import React from "react";
import "./ModalCustomLegend.scss";
import {
  LEGEND_CUMULATIVE_ACTUAL_CLEARED,
  LEGEND_CUMULATIVE_ACTUAL_PROJECTED,
  LEGEND_CUMULATIVE_BUDGET,
  LEGEND_CUMULATIVE_IDEAL_CLEARED,
  LEGEND_CUMULATIVE_IDEAL_PROJECTED,
  LEGEND_DAILY_ACTUAL_CLEARED,
  LEGEND_DAILY_ACTUAL_PROJECTED,
  LEGEND_DAILY_IDEAL_CLEARED,
  LEGEND_DAILY_IDEAL_PROJECTED,
} from "./ModalCustomLegendIcons";

interface ModalCustomLegendProps {
  className?: string;
  graphView?: boolean;
}

const ModalCustomLegend: React.FC<ModalCustomLegendProps> = ({ className, graphView }) => {
  return (
    <div>
      {graphView && (
        <div className="modalLegend">
          <div className="modalLegendSection">
            <div className="modalLegendtitle">Actual Delivery</div>
            <div className="modalItems">
              {LEGEND_CUMULATIVE_ACTUAL_CLEARED}
              <div className="modalLabel">Actual</div>
            </div>
            <div className="modalItems">
              {LEGEND_CUMULATIVE_ACTUAL_PROJECTED}
              <div className="modalLabel">Projected</div>
            </div>
          </div>
          <div className="modalLegendSection">
            <div className="modalLegendtitle">Ideal Delivery</div>
            <div className="modalItems">
              {LEGEND_CUMULATIVE_IDEAL_CLEARED}
              <div className="modalLabel">Actual</div>
            </div>
            <div className="modalItems">
              {LEGEND_CUMULATIVE_IDEAL_PROJECTED}
              <div className="modalLabel">Projected</div>
            </div>
          </div>
          <div className="modalLegendSection">
            <div className="modalLegendtitle">Budget</div>
            <div className="modalItems">
              {LEGEND_CUMULATIVE_BUDGET}
              <div className="modalLabel">Budget</div>
            </div>
          </div>
        </div>
      )}
      {!graphView && (
        <div className="modalLegend">
          <div className="modalLegendSection">
            <div className="modalLegendtitle">Actual Delivery</div>
            <div className="modalItems">
              {LEGEND_DAILY_ACTUAL_CLEARED}
              <div className="modalLabel">Actual</div>
            </div>
            <div className="modalItems">
              {LEGEND_DAILY_ACTUAL_PROJECTED}
              <div className="modalLabel">Projected</div>
            </div>
          </div>
          <div className="modalLegendSection">
            <div className="modalLegendtitle">Ideal Delivery</div>
            <div className="modalItems">
              {LEGEND_DAILY_IDEAL_CLEARED}
              <div className="modalLabel">Actual</div>
            </div>
            <div className="modalItems">
              {LEGEND_DAILY_IDEAL_PROJECTED}
              <div className="modalLabel">Projected</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalCustomLegend;
